import React, { useEffect, useContext } from 'react';
import { useSession } from 'next-auth/react';
import { Box, Text, Center, Wrap } from '@chakra-ui/react';
import { useFirebaseUser } from '../../utils/useFirebaseUser';
import PuffLoader from 'react-spinners/PuffLoader';
import { TweetContext } from 'context/tweetContext';
import { GhostwriterClientTile } from './ghostwriterClientTile';

let tabs = ['Personal information', 'My services', 'My reviews'];

export interface GhostwriterAllClientsProps {
  setSelectedCreator: (client: any) => void;
  setTabIndex: (index: number) => void;
}

export const GhostwriterAllClients = ({
  setSelectedCreator,
  setTabIndex,
}: GhostwriterAllClientsProps) => {
  const { data: session } = useSession() ?? {};
  const isAuthenticated = useFirebaseUser();

  const tweetContext: any = useContext(TweetContext);

  const [isLoading, setIsLoading] = React.useState(false);
  const [clients, setClients] = React.useState<any>([]);

  useEffect(() => {
    if (isAuthenticated) {
      let accounts = session?.user?.data?.linkAccounts ?? [];
      setClients(accounts);
    }
  }, [isAuthenticated, tweetContext.refresh]);

  return (
    <Box>
      {isLoading ? (
        <Center pt={20} w="100%">
          <PuffLoader
            color={'#0A66C2'}
            loading={isLoading}
            cssOverride={{
              display: 'block',
              margin: '0 auto',
              borderColor: 'red',
            }}
            size={50}
          />
        </Center>
      ) : clients?.length > 0 ? (
        <Wrap spacing="4">
          {clients.map((client, index) => (
            <GhostwriterClientTile
              key={client.twUserName}
              client={client}
              setSelectedCreator={setSelectedCreator}
              setTabIndex={setTabIndex}
            />
          ))}
        </Wrap>
      ) : (
        <Text mt={20}>
          Ask your clients to give you their personal link to start writing for
          them
        </Text>
      )}
    </Box>
  );
};
